import { ProcedureGroup } from "@/model/Procedure/ProcedureGroup";

export const isLink = (folderId: number, groupList: ProcedureGroup[]) => {
	return groupList.find((group) => group.Id === folderId && group.Link);
};
